import { withStyles, withTheme } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { compose } from 'recompose';
import Arrow from "@material-ui/icons/TrendingFlat";

const SortingArrow = ({ classes, activeSortOption }) => (
  <div className={classes.headerIcons}>
    {Boolean(activeSortOption) && (
      <Arrow
        classes={{ root: activeSortOption === 1 ? classes.sortAsc : classes.sortDesc }}
      />
    )}
  </div>
);

const styles = (theme) => ({
  container: {
    display: 'flex',
    padding: 0,
    width: 'calc(100% - 16px)',
    '&:hover $filterIcon': {
      visibility: 'visible',
      color: theme.iconColor
    },
    '& $filterIcon:hover': {
      color: theme.HeaderSelectedText
    }
  },
  customHeader: {
    paddingLeft: 8,
    display: 'flex',
    width: 'calc(100% - 16px)',
    cursor: 'pointer'
  },
  headerIcons: {
    color: theme.HeaderSelectedText,
    width: 16,
    paddingTop: 2,
    '&$filterIcon$filterActive': {
      color: theme.HeaderSelectedText
    }
  },
  filterIcon: {
    visibility: 'hidden',
    cursor: 'pointer',
    color: theme.HeaderSelectedText,
    padding: '4px 0px 0px 4px'
  },
  filterActive: {
    visibility: 'visible',
    color: theme.HeaderSelectedText
  },
  iconClass: {
    color: theme.HeaderSelectedText
  },
  sortAsc: {
    transform: 'rotate(270deg)'
  },
  sortDesc: {
    transform: 'rotate(90deg)'
  },
  // Uses AG Grid theme parameters: headerFontSize -> --ag-header-font-size, headerFontWeight -> --ag-header-font-weight
  // These can be customized in agGridThemes.js or via CSS custom properties
  headerText: {
    cursor: 'pointer',
    fontSize: 'var(--ag-header-font-size)',
  },
  iconHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '100%'
  }
});
const CustomGridHeader = ({
  classes,
  theme,
  column,
  displayName,
  enableSorting,
  enableMenu,
  showColumnMenu,
  setSort,
  eGridHeader
}) => {
  const [activeSortOption, setActiveSortOption] = useState(0);
  const [filterActive, setFilterActive] = useState(null);
  const containerRef = useRef(null);

  const sortOptions = [null, 'asc', 'desc'];
  const isHeaderDragged = useRef(null);

  useEffect(() => {
    eGridHeader.classList.add(classes.container)
    const onSortChanged = () => {
      const sortAscending = column.isSortAscending();
      const sortDescending = column.isSortDescending();
      
      let activeSortOption;
      if (sortAscending) {
        activeSortOption = 1;
      } else if (sortDescending) {
        activeSortOption = 2;
      } else {
        activeSortOption = 0;
      }
      
      setActiveSortOption(activeSortOption);
    };

    const onFilterChanged = () => {
      setFilterActive(column.isFilterActive());
    };

    // Initialize state on mount to handle AG Grid's component recreation on scroll.
    onSortChanged();
    onFilterChanged();

    column.addEventListener('sortChanged', onSortChanged);
    column.addEventListener('filterChanged', onFilterChanged);

    return () => {
      column.removeEventListener('sortChanged', onSortChanged);
      column.removeEventListener('filterChanged', onFilterChanged);
    };
  }, [column]);

  useEffect(() => {
    if (eGridHeader) {
      if (activeSortOption) {
        eGridHeader.classList.add("sortedColumn");
      } else {
        eGridHeader.classList.remove("sortedColumn");
      }
    }
  }, [activeSortOption, eGridHeader]);

  const onMenuClicked = () => {
    showColumnMenu(containerRef.current);
  };

  const onSortRequested = (event) => {
    if (isHeaderDragged?.current) {
      isHeaderDragged.current = false;
    } else {
      const sortOption = (activeSortOption + 1) % sortOptions.length;
      setSort(sortOptions[sortOption], event.shiftKey);
    }
  };

  const onMouseLeave = (event) => {
    const themeClass = `theme-${theme.themeName}`;
    Array.from(document.getElementsByClassName('ag-dnd-ghost')).forEach((ele) => {
      if (!ele.classList.contains(themeClass)) {
        ele.classList.add(themeClass);
        ele.classList.add(`columnMoveGhost`);
        isHeaderDragged.current = true;
      }
    });
  };

  // Check if column has a custom header icon
  const CustomHeaderIcon = column.colDef?.headerIcon;
  const hasCustomIcon = Boolean(CustomHeaderIcon);

  return (
    <>
      <div
        className={classes.customHeader}
        onMouseLeave={onMouseLeave}
        onClick={enableSorting ? onSortRequested : () => {}}>
        {hasCustomIcon ? (
          <div className={classes.iconHeader}>
            <SortingArrow classes={classes} activeSortOption={activeSortOption} />
            <CustomHeaderIcon />
          </div>
        ) : (
          <>
            <SortingArrow classes={classes} activeSortOption={activeSortOption} />
            <div className={classes.headerText}>{displayName}</div>
          </>
        )}
      </div>
      {column.colDef?.filter && (
        <div
          ref={containerRef}
          className={`${classes.headerIcons} ${classes.filterIcon} ${
            filterActive ? classes.filterActive : ''
          } filterIcon`}
          onClick={onMenuClicked}>
          {filterActive ? <i className="icon-filter" /> : <i className="icon-icon_filter" />}
        </div>
      )}
    </>
  );
};

export default compose(withStyles(styles), withTheme())(CustomGridHeader);
